const STANDARD_PREFIX_PHONE = [
    {old_prefix: "0162", new_prefix: "032"},
    {old_prefix: "0163", new_prefix: "033"},
    {old_prefix: "0164", new_prefix: "034"},
    {old_prefix: "0165", new_prefix: "035"},
    {old_prefix: "0166", new_prefix: "036"},
    {old_prefix: "0167", new_prefix: "037"},
    {old_prefix: "0168", new_prefix: "038"},
    {old_prefix: "0169", new_prefix: "039"},
    {old_prefix: "0120", new_prefix: "070"},
    {old_prefix: "0121", new_prefix: "079"},
    {old_prefix: "0122", new_prefix: "077"},
    {old_prefix: "0126", new_prefix: "076"},
    {old_prefix: "0128", new_prefix: "078"},
    {old_prefix: "0123", new_prefix: "083"},
    {old_prefix: "0124", new_prefix: "084"},
    {old_prefix: "0125", new_prefix: "085"},
    {old_prefix: "0127", new_prefix: "081"},
    {old_prefix: "0129", new_prefix: "082"},
    {old_prefix: "0186", new_prefix: "056"},
    {old_prefix: "0188", new_prefix: "058"},
    {old_prefix: "0199", new_prefix: "059"},
]

export const standardPrefixPhones = (strPhones, char = ";") => {
    // if (strPhones.length <= 10) {
    //     return strPhones
    // }

    if (!strPhones) {
        return ""
    }

    const arrPhone = strPhones.split(char)
    let out = []
    for (let i = 0; i < arrPhone.length; i++) {
        let p = arrPhone[i]
        // Convert prefix 84 => 0
        if (p.startsWith("84")) {
            p = "0" + p.substr(2)
        }
        let hasPrefix = false
        for (let j = 0; j < STANDARD_PREFIX_PHONE.length; j++) {
            const ppf = STANDARD_PREFIX_PHONE[j]
            if (p.length >= 10 && p.startsWith(ppf.old_prefix)) {
                out.push(ppf.new_prefix + p.substr(ppf.old_prefix.length))
                hasPrefix = true
                break
            }
        }
        if (!hasPrefix) {
            out.push(p)
        }
    }

    return out.join(char)
}